module.exports = __webpack_public_path__ + "static/media/kenn_richtig.6ca84199.jpg";